<template>
  <div id="app">
    <Header v-show = "version == 1"></Header>
    <HeaderV2 v-show = "version == 2"></HeaderV2>
	<HeaderV3 v-show = "version == 3"></HeaderV3>
    <router-view/>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
	name: 'App',
	data:function(){
		return{
			version:1,
			timeInt:"",
		}
	},
	created: function() {
		clearInterval(this.timeInt);
		this.changePlat();
	},
	methods: {
		changePlat(){
			var _this = this;
			this.timeInt = setInterval(function(){
				//console.log(_this.$route.query.version);
				if(typeof _this.$route.query.version == "undefined"){
					_this.version = 1;
				}
				//console.log(_this.version);
				if(_this.$route.query.version){
					_this.version = _this.$route.query.version;
				}else{
					_this.version = 1;
				}
			},100);
		},
	}
}

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue